export default __webpack_public_path__ + "static/media/skyline.27135e45.jpeg";